/* Modules */
import dynamic from './modules/dynamic';

dynamic().init();

const calcViewportUnits = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
};
window.addEventListener('resize', calcViewportUnits);
calcViewportUnits();



// WEBPACK FOOTER //
// ./web/assets/src/js/main.js